import React from 'react';
import { Provider } from 'react-redux';
import { store } from '../store';

export const provideReduxToModules = (modules) =>
  modules.map((moduleData) => ({
    ...moduleData,
    module: (
      <Provider store={store}>
        <moduleData.module />
      </Provider>
    ),
  }));

export default provideReduxToModules;
